import * as React from "react";
const SvgCross = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 6, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13,13l38,38M13,51l38,-38" }));
export default SvgCross;
